import { h } from 'preact';
import Store from 'store/store';

const getOneTrustCookieSettingButtonText = (() => {
	let cache = null;
	return () => {
		if (cache) return cache;
		if (typeof window?.OneTrust?.GetDomainData !== 'function') {
			return null;
		}
		return cache = window.OneTrust.GetDomainData()?.CookieSettingButtonText || null;
	};
})();

export function showCookieConsent() {
	window.OneTrust?.ToggleInfoDisplay?.();
}

export function renderCookieConsentLink(linkName) {
	const { appData, client } = Store.get();
	const regionsToShowImg = appData?.options?.oneTrustCookieConsent?.regionsToShowImg?.split(',')?.map(r => r.trim().toLowerCase()) || [];
	const countryCode = client?.geo?.countryCode?.toLowerCase();
	const showImg = countryCode && regionsToShowImg.includes(countryCode);

	const name = getOneTrustCookieSettingButtonText() || linkName;

	return (
		<button class="cookie-consent" onClick={showCookieConsent}>
			{showImg && <img class="do-not-sell" src={`${__IMAGE_ROOT__}/privacyoptions.svg`} role="presentation" />}
			{name}
		</button>
	);
}